
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"SERVER OBJECTS"'></app-infrastructure-header>

<!-- Main Screen which shows the Server Objects and Server Object Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#server-object-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> SERVER OBJECTS</a></li>
			<li class=""><a data-toggle="tab" href="#server-objects-tab" aria-expanded="false"><i class="fa fa-star-o"></i> SERVER OBJECT TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Server Objects Tab -->
			<div id="server-objects-tab" class="tab-pane fade">

				<!-- Add Server Object Type and Options buttons -->
				<button (click)="addServerObjectClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em>
					ADD SERVER OBJECT TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedServerObjectClicked()"
							[class.disabled]="!isSingleServerObjectSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedServerObjectClicked()"
							[class.disabled]="!isSingleServerObjectSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedServerObjectsClicked()"
							[class.disabled]="!isAnyServerObjectsSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedServerObjectsToGroupClicked()"
							[class.disabled]="!isAnyServerObjectsSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedServerObjectsFromGroupClicked()"
							[class.disabled]="!isAnyServerObjectsSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageServerObjectGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
					</ul>
				</div>

				<!-- "Filter" Button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionForServerObjects" (click)="onFilterOptionForServerObjectClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>
	
				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="selectedFilterOptionForServerObject?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ selectedFilterOptionForServerObject.label }}
				</div>
	
				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="selectedFilterOptionForServerObject?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
						[(ngModel)]="filterOptionValueForServerObject"
						(ngModelChange)="onFilterValueForServerObjectChanged()">
				</div>
	
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>


				<!-- Server Objects -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllServerObjectsSelected()"
										(change)="setAllServerObjectsSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let serverObject of mServerObjects | paginate: {id: 'serverobject_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForServerObject, totalItems: totalNumberOfServerObjects}">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="serverObject.mSelected" /></td>
								<td (click)="editServerObject(serverObject.mServerObject)">
									{{serverObject.mServerObject.name}}</td>
								<td>
									<ng-container
										*ngIf="serverObject.mServerObject.groups != null && serverObject.mServerObject.groups.length > 0">
										<ng-container *ngFor="let group of serverObject.mServerObject.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Server Object" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="serverobject_pagination" (pageChange)="pageChangedServerObject($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>


			</div>

			<!-- Server Object Instances Tab -->
			<div id="server-object-instances-tab" class="tab-pane fade active in">

				<!-- Add Server Object and Options buttons -->
				<button (click)="addServerObjectInstanceClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD SERVER OBJECT</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedServerObjectInstanceClicked()"
							[class.disabled]="!isSingleServerObjectInstanceSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedServerObjectInstanceClicked()"
							[class.disabled]="!isSingleServerObjectInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedServerObjectInstancesClicked()"
							[class.disabled]="!isAnyServerObjectInstancesSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedServerObjectInstancesToGroupClicked()"
							[class.disabled]="!isAnyServerObjectInstancesSelected()"><a><em class="fa fa-plus"></em> ADD
								TO GROUP</a></li>
						<li (click)="removeSelectedServerObjectInstancesFromGroupClicked()"
							[class.disabled]="!isAnyServerObjectInstancesSelected()"><a><em class="fa fa-remove"></em>
								REMOVE FROM GROUP</a></li>
						<li (click)="manageServerObjectInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
					</ul>
				</div>

				<!-- "Filter" button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionForServerObjectInstances" (click)="onFilterOptionForServerObjectInstanceClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="selectedFilterOptionForServerObjectInstance?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ selectedFilterOptionForServerObjectInstance.label }}
				</div>

				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="selectedFilterOptionForServerObjectInstance?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text"
						[(ngModel)]="filterOptionValueForServerObjectInstance"
						(ngModelChange)="onFilterValueForServerObjectInstanceChanged()">
				</div>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>
				<!-- Server Object Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllServerObjectInstancesSelected()"
										(change)="setAllServerObjectInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Server Object Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let serverObjectInstance of mServerObjectInstances | paginate: {id: 'serverobjectinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForServerObjectInstance, totalItems: totalNumberOfServerObjectInstances}">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="serverObjectInstance.mSelected" /></td>
								<td (click)="editServerObjectInstance(serverObjectInstance.mServerObjectInstance)" (contextmenu)="fetchFunctionList($event, serverObjectInstance.mServerObjectInstance)">
									{{serverObjectInstance.mServerObjectInstance.name}}</td>
								<td (click)="editServerObjectInstance(serverObjectInstance.mServerObjectInstance)">
									{{serverObjectInstance.mServerObjectInstance.serverObject.name}}</td>
								<td>
									<ng-container
										*ngIf="serverObjectInstance.mServerObjectInstance.groups != null && serverObjectInstance.mServerObjectInstance.groups.length > 0">
										<ng-container
											*ngFor="let group of serverObjectInstance.mServerObjectInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Server Object" Instance (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="serverobjectinstance_pagination"
					(pageChange)="pageChangedServerObjectInstance($event)" [directionLinks]="true"
					nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance"
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance"
	[instanceType]="mInstanceType" [function]="selectedFunction"></app-general-function-dialog>
